import { useLocation } from 'react-router-dom';

export const useOpenReportingLocation = () => {
  const location = useLocation();
  const pathParts = location.pathname.split('/');
  const isOpenReporting =
    pathParts.length > 2 && pathParts[2] === 'open-reporting';

  const basePath =
    pathParts.length > 2 ? `/${pathParts[1]}/${pathParts[2]}` : '';
  const [, orgSlug] = pathParts;
  const page = pathParts.length > 3 ? pathParts[3] : '';
  return {
    isOpenReporting,
    basePath,
    orgSlug,
    page,
  };
};
